import type { FiltersSelection } from "~/core/models/filters";
import RestService from "~/core/services/rest.service";
import type { DeviceModelSpecificConfig } from "~/modules/globalDeviceConfiguration/models/DeviceModelSpecificConfig.interface";
import organizationService from "~/modules/organization/services/organization.service";

export class GlobalDeviceConfigurationService extends RestService {
  async getOrganizationAllDeviceModelSpecificConfigs({
    organizationCode,
    searchParams,
    params,
  }: {
    organizationCode?: number;
    searchParams?: string | FiltersSelection;
    params?: Map<string, unknown>;
  }): Promise<DeviceModelSpecificConfig[]> {
    return this.$apiV2.get(
      this.getOrganizationDtwinsDeviceModelConfigsPath(organizationCode),
      {
        params: {
          filter: searchParams,
          ...Object.fromEntries(params || new Map()),
        },
      },
    );
  }

  async updateOrganizationDeviceModelSpecificConfig({
    organizationCode,
    deviceModelSpecificConfig,
  }: {
    organizationCode?: number;
    deviceModelSpecificConfig: DeviceModelSpecificConfig;
  }) {
    return this.$apiV2.put(
      `${this.getOrganizationDtwinsDeviceModelConfigsPath(organizationCode)}/${deviceModelSpecificConfig.deviceModelUid}`,
      deviceModelSpecificConfig,
    );
  }

  private getOrganizationDtwinsDeviceModelConfigsPath(
    organizationCode?: number,
  ) {
    return `${organizationService.getOrganizationPath(organizationCode)}/dtwins/deviceModelConfigs`;
  }
}

export default new GlobalDeviceConfigurationService();
